/* 🤖 this file was generated by svg-to-ts */
export var spxIconTick01 = {
    name: 'tick_01',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 14L8.5 17.5L19 6.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
